import React, { useState } from 'react'
import Modal from '../modal'
import CloseSVG from '../../../assets/svg/close.svg'
import FormInput from '../../form-input'
import { useForm } from 'react-hook-form'
import Button from '../../button'
import { useSetReimbursementLimit } from '../../../redux/employees/hook/reimbursements'
import { useDispatch, useSelector } from 'react-redux'
import { setCompany } from '../../../redux/company/reducer'

const SetReimbursementLimit = ({ isOpen, closeModal }) => {
  const { company } = useSelector((state) => state.companySlice)
  const dispatch = useDispatch()

  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const { mutateAsync: setReimbursementLimit, isLoading } =
    useSetReimbursementLimit()
  const [amountEdit, setAmountEdit] = useState(company?.reimbursement_limit)
  const submitForm = async (data) => {
    let payload = {
      reimbursement_limit: amountEdit,
    }
    await setReimbursementLimit(payload).then(() => {
      dispatch(
        setCompany({
          ...company,
          reimbursement_limit: res.data.reimbursement_limit,
        })
      )
      closeModal()
    })
  }
  return (
    <Modal
      scrollable={true}
      className='!max-w-[500px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <form className='form pb-4' onSubmit={handleSubmit(submitForm)}>
        <div className='flex flex-row justify-between px-8 pt-4 items-center'>
          <span className='header-4'>Update Reimbursement Limit</span>
          <div className='cursor-pointer' onClick={() => closeModal()}>
            <img src={CloseSVG} alt='close' />
          </div>
        </div>
        <div className='w-full mt-3 px-8'>
          <FormInput
            label='Maximum Reimburment Amount'
            name='amount'
            type='number'
            placeholder='Enter amount'
            readOnly={isLoading}
            value={amountEdit}
            onInput={(e) => {
              setAmountEdit(e.target.value)
            }}
            error={errors.amount}
            errorMessage={errors.amount && errors.amount.message}
          />
          <div className='w-full mt-[20px]'>
            <Button
              text={'Update limit'}
              type='submit'
              disabled={isLoading}
              loading={isLoading}
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default SetReimbursementLimit
